export enum EWidgetType {
	ADD_FUNDS = "ADD_FUNDS",
	BUY_NFT = "BUY_NFT",
	MINT = "MINT",
}
